export default __webpack_public_path__ + "static/media/inspector-text-align-top.43258218.svg";